import { Button, ButtonType } from "./Button";

export class LoaderButton extends Button {
    private _isLoading: boolean = false;

    public get isLoading(): boolean {
        return this._isLoading;
    }

    public set isLoading(val: boolean) {
        this._isLoading = val;

        if (val) this.element.classList.add("icon", "upload");
        else this.element.classList.remove("icon", "upload");
    }

    /**
     * @param lockey popisek
     * @param type typ tlacitka
     * @param rounded ma mit tlacitko zakulacene rohy? defaultne false
     * @param element nepovinny param. Element, ze ktereho se vytvori button.
     * Pokud neni zadany, vytvori se novy element
     */
    constructor(lockey: string, type: ButtonType, rounded: boolean = false, element?: HTMLDivElement) {
        super(lockey, undefined, type, rounded, element);

        this.element.classList.add("loader-button");

        this.element.insertAdjacentHTML("afterbegin",
            `<div class="loader-container">
               <div class="loader">
                <div class="left">
                    <div class="border"></div>
                </div>
                <div class="right">
                    <div class="border"></div>
                </div>
            </div>
        </div`);
    }
}
